import React from 'react';
import { observer } from 'mobx-react-lite';
import { StaffAccountBasicDataType } from 'src/AppState/sdk/staff';
import { List } from 'immutable';
import {
    CustomerContentTab,
    CustomerContentWrapper,
    CustomerMainTabWrapper,
    LhsMenuCustomer,
    MainTabItem,
} from 'src/components/CustomersBar/CustomerTab/Menu/MenuLinks.style';
import { CustomerMenuItems } from 'src/components/CustomersBar/CustomerTab/Menu/CustomerMenu/CustomerMenuItems';
import { EventsTab } from 'src/components/CustomersBar/EventsTab/EventsTab';
import { EventsTabContent } from 'src/components/CustomersBar/EventsTab/EventsTabContent';
import { useAppStateContext } from 'src/AppState/AppState';
import { CustomerContent } from 'src/components/CustomersBar/CustomerTab/Menu/CustomerMenu/CustomerContent';

interface MenuLinksType {
    id: number;
    onQueryAudits: (
        id: string,
        topic: string,
        tag: string | Array<string>,
        filterName: string | null
    ) => (e: React.MouseEvent) => void;
    onShowAll: (id: string, topic: string, tag: Array<string>) => (e: React.MouseEvent) => void;
    customerData: StaffAccountBasicDataType;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    permissionGrants: List<any>;
}

export const MenuLinks = observer((props: MenuLinksType): JSX.Element | null => {
    const { eventsTabState, routerBackoffice } = useAppStateContext();
    const { customerData, id, onShowAll, onQueryAudits, permissionGrants } = props;
    const customerParams = routerBackoffice.getParametersString('customers', 'tab') ?? 'customer';

    const isTabActive = (label: string): boolean => {
        return customerParams === label;
    };

    return (
        <CustomerContentTab className='tabs__vertical tabs__customers-events'>
            <LhsMenuCustomer>
                <CustomerMainTabWrapper>
                    <MainTabItem
                        isActive={isTabActive('customer')}
                        onClick={(): void => routerBackoffice.redirectToCustomer()}
                        data-test='customer-tab'
                    >
                        Customer
                    </MainTabItem>
                    <MainTabItem
                        isActive={isTabActive('telebet')}
                        onClick={(): void => routerBackoffice.redirectToTelebet()}
                        data-test='telebet-tab'
                    >
                        Telebet
                    </MainTabItem>
                </CustomerMainTabWrapper>

                {isTabActive('customer') ? (
                    <CustomerMenuItems
                        id={id}
                        onQueryAudits={onQueryAudits}
                    />
                ) : (
                    <EventsTab
                        key='telebet'
                        label='Telebet'
                        id={id}
                    />
                )}
            </LhsMenuCustomer>

            <CustomerContentWrapper>
                {isTabActive('customer') ? (
                    <CustomerContent
                        customerData={customerData}
                        id={id}
                        onQueryAudits={onQueryAudits}
                        onShowAll={onShowAll}
                        permissionGrants={permissionGrants}
                    />
                ) : (
                    <EventsTabContent
                        sportId={eventsTabState.currentActiveTab}
                        userId={id}
                    />
                )}
            </CustomerContentWrapper>
        </CustomerContentTab>
    );
});
